import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Declare fbq as a global function to avoid TypeScript errors
declare global {
  interface Window {
    fbq: any;
  }
}

const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track pageview on route change
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);

  return null;
};

export default MetaPixelTracker;
